import type { WaitlistExperienceLevel, WaitlistSource } from '@prepzio/shared';

const API_URL =
  (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ??
  'http://localhost:8787';

export type WaitlistPayload = {
  email: string;

  source: WaitlistSource;

  experienceLevel?: WaitlistExperienceLevel;

  aiTools?: string[];

  mainPain?: string;

  website?: string;

  referrer?: string;

  utmSource?: string;

  utmMedium?: string;

  utmCampaign?: string;

  turnstileToken?: string;
};

export type WaitlistResult =
  { ok: true; status: 'joined' | 'already_joined' } | { ok: false; code: string; message: string };

export const joinWaitlist = async (payload: WaitlistPayload): Promise<WaitlistResult> => {
  try {
    const res = await fetch(`${API_URL}/v1/waitlist`, {
      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify(payload),
    });

    if (res.ok) {
      let status: 'joined' | 'already_joined' = 'joined';

      try {
        const data = (await res.json()) as { data?: { status?: string } };

        if (data.data?.status === 'already_joined') status = 'already_joined';
      } catch {
        // ignore parsing errors — treat as joined
      }

      return { ok: true, status };
    }

    let code = 'HTTP_ERROR';

    let message = 'Something went wrong. Please try again.';

    try {
      const data = (await res.json()) as {
        error?: { code?: string; message?: string };
      };

      if (data.error?.code) code = data.error.code;

      if (data.error?.message) message = data.error.message;
    } catch {
      // ignore parsing errors
    }

    return { ok: false, code, message };
  } catch {
    return {
      ok: false,

      code: 'NETWORK',

      message: 'Could not reach the server. Check your connection.',
    };
  }
};

export const readUtmParams = () => {
  if (typeof window === 'undefined') return {};

  const sp = new URLSearchParams(window.location.search);

  const pick = (k: string) => {
    const v = sp.get(k);

    return v && v.length > 0 ? v.slice(0, 120) : undefined;
  };

  return {
    utmSource: pick('utm_source'),

    utmMedium: pick('utm_medium'),

    utmCampaign: pick('utm_campaign'),

    referrer:
      typeof document !== 'undefined' && document.referrer
        ? document.referrer.slice(0, 512)
        : undefined,
  };
};
